export enum ContractSignMode {
  Rextie = 'rextie',
  Confirming = 'confirming',
  Default = 'default',
}
